/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 1;
export const GenericDomainEntity = new AjvReflection('GenericDomainEntity', {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        type: {
            type: 'string'
        }
    },
    additionalProperties: true,
    required: [
        'id',
        'type'
    ]
});
export const RecipeConfiguration = new AjvReflection('RecipeConfiguration', {
    type: 'object',
    properties: {
        modelVersion: {
            type: 'integer'
        },
        entities: {
            type: 'array',
            items: GenericDomainEntity._meta.schema
        },
        rootEntityType: {
            type: 'string'
        },
        rootRecipeId: {
            type: 'string'
        },
        recipeIds: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        configurationId: {
            type: 'string'
        },
        revisionId: {
            type: 'string'
        },
        ownerToken: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'entities',
        'rootEntityType',
        'rootRecipeId',
        'recipeIds',
        'modelVersion',
        'configurationId',
        'revisionId',
        'ownerToken'
    ]
});
export const CabinetWoodTextureMaterials = new EnumReflection('CabinetWoodTextureMaterials', {
    enum: [
        'lightWoodMaterial',
        'darkWoodMaterial',
        'whiteWoodMaterial'
    ]
});
export const CountertopWoodTextureMaterials = new EnumReflection('CountertopWoodTextureMaterials', {
    enum: [
        'butcherBlockMaterial'
    ]
});
const CommonAdminEntityShape = new AjvReflection('CommonAdminEntityShape', {
    type: 'object',
    properties: {
        commonAdminModelVersion: {
            enum: [
                3
            ]
        }
    },
    additionalProperties: false,
    required: [
        'commonAdminModelVersion'
    ]
});
const PresetCategoryShape = new AjvReflection('PresetCategoryShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        description: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'index',
        'visible',
        'description'
    ]
});
const PresetShape = new AjvReflection('PresetShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        categoryId: {
            oneOf: [
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                },
                {
                    type: 'null'
                }
            ]
        },
        configurationId: {
            type: [
                'string',
                'null'
            ]
        },
        revisionId: {
            type: [
                'string',
                'null'
            ]
        },
        ownerToken: {
            type: [
                'string',
                'null'
            ]
        },
        readToken: {
            type: [
                'string',
                'null'
            ]
        },
        thumbnailUrl: {
            type: [
                'string',
                'null'
            ]
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'description',
        'index',
        'visible',
        'categoryId',
        'configurationId',
        'revisionId',
        'ownerToken',
        'readToken',
        'thumbnailUrl',
        'tags'
    ]
});
const RecipeShape = new AjvReflection('RecipeShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        collection: {
            type: 'string'
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        configuration: {
            anyOf: [
                RecipeConfiguration._meta.schema,
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'description',
        'collection',
        'index',
        'visible',
        'configuration'
    ]
});
const SegmentPriceShape = new AjvReflection('SegmentPriceShape', {
    type: 'object',
    properties: {
        product_code: {
            type: 'string'
        },
        material_type: {
            type: 'string'
        },
        width: {
            type: 'number'
        },
        price: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'product_code',
        'material_type',
        'width',
        'price'
    ]
});
const SolidColorMaterialShape = new AjvReflection('SolidColorMaterialShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        color: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'color'
    ]
});
const CabinetWoodTextureMaterialShape = new AjvReflection('CabinetWoodTextureMaterialShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        materialName: CabinetWoodTextureMaterials._meta.schema
    },
    additionalProperties: false,
    required: [
        'name',
        'materialName'
    ]
});
const CountertopWoodTextureMaterialShape = new AjvReflection('CountertopWoodTextureMaterialShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        materialName: CountertopWoodTextureMaterials._meta.schema
    },
    additionalProperties: false,
    required: [
        'name',
        'materialName'
    ]
});
export const Admin = new DomainEntityReflection('Admin', [
    CommonAdminEntityShape._meta.schema
]);
export const Preset = new DomainEntityReflection('Preset', [
    PresetShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const PresetCategory = new DomainEntityReflection('PresetCategory', [
    PresetCategoryShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const Recipe = new DomainEntityReflection('Recipe', [
    RecipeShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const DummyDoNotUse = new DomainEntityReflection('DummyDoNotUse', []);
export const CabinetSolidColorMaterial = new DomainEntityReflection('CabinetSolidColorMaterial', [
    SolidColorMaterialShape._meta.schema
]);
export const CabinetWoodTextureMaterial = new DomainEntityReflection('CabinetWoodTextureMaterial', [
    CabinetWoodTextureMaterialShape._meta.schema
]);
export const CountertopSolidColorMaterial = new DomainEntityReflection('CountertopSolidColorMaterial', [
    SolidColorMaterialShape._meta.schema
]);
export const CountertopWoodTextureMaterial = new DomainEntityReflection('CountertopWoodTextureMaterial', [
    CountertopWoodTextureMaterialShape._meta.schema
]);
export const SegmentPrice = new DomainEntityReflection('SegmentPrice', [
    SegmentPriceShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    Admin,
    Preset,
    PresetCategory,
    Recipe,
    DummyDoNotUse,
    CabinetSolidColorMaterial,
    CabinetWoodTextureMaterial,
    CountertopSolidColorMaterial,
    CountertopWoodTextureMaterial,
    SegmentPrice
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Admin
]);
export const CommonAdminEntity = new RawAliasReflection('CommonAdminEntity', [
    Admin,
    Preset,
    PresetCategory,
    Recipe
]);
export const SolidColorMaterial = new RawAliasReflection('SolidColorMaterial', [
    CabinetSolidColorMaterial,
    CountertopSolidColorMaterial
]);
export const WoodTextureMaterial = new RawAliasReflection('WoodTextureMaterial', [
    CabinetWoodTextureMaterial,
    CountertopWoodTextureMaterial
]);
export const CabinetMaterial = new RawAliasReflection('CabinetMaterial', [
    CabinetSolidColorMaterial,
    CabinetWoodTextureMaterial
]);
export const CountertopMaterial = new RawAliasReflection('CountertopMaterial', [
    CountertopSolidColorMaterial,
    CountertopWoodTextureMaterial
]);
export const Material = new RawAliasReflection('Material', [
    ...CabinetMaterial.reflections,
    ...CountertopMaterial.reflections
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    CommonAdminEntity: CommonAdminEntity.types,
    SolidColorMaterial: SolidColorMaterial.types,
    WoodTextureMaterial: WoodTextureMaterial.types,
    CabinetMaterial: CabinetMaterial.types,
    CountertopMaterial: CountertopMaterial.types,
    Material: Material.types
};
export const entities = {
    Admin,
    Preset,
    PresetCategory,
    Recipe,
    DummyDoNotUse,
    CabinetSolidColorMaterial,
    CabinetWoodTextureMaterial,
    CountertopSolidColorMaterial,
    CountertopWoodTextureMaterial,
    SegmentPrice
};

//# sourceMappingURL=v1.js.map